<canvas class="pad" #canvas></canvas>

<div class="clear" title="Clear signature" (click)="onRemoveClicked()">Clear</div>
